import { SVGProps } from 'react';

const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14" {...props}>
        <path d="M9.11 13.127a.745.745 0 0 1-.225.646.774.774 0 0 1-1.096 0L4.67 10.654a.77.77 0 0 1-.225-.645V6.027L.72 1.26A.778.778 0 0 1 .852.17.81.81 0 0 1 1.334 0H12.22a.81.81 0 0 1 .482.171.778.778 0 0 1 .133 1.089L9.11 6.027v7.1ZM2.92 1.555 6 5.49v4.293l1.555 1.555V5.483l3.08-3.928H2.92Z" />
    </svg>
);
export default SvgFilter;
